<template>
    <div class="py-3" style="border-bottom:1px solid #e9e9e9; overflow-x:auto">
        <p class="fkr-set2 fs-13" style="padding-left:45px"><strong>다른 프로젝트 보기</strong></p>
        <div v-if="isMobile" class="d-flex align-items-center" style="justify-content: center; gap: 15px; ">
            <a href="javascript:void(0)" @click="moveNav(0)"
                style="display: flex; align-items: center; flex-shrink: 0;">
                <img src="@/assets/img/s_arrow_l.png" width="35px" height="35px">
            </a>
            <div style="flex: 1; overflow: hidden;">
                <a class="w-100" :href="navSlot[0].pageLink" style="display: block;">
                    <img :src="navSlot[0].imgSrc" width="100%"
                        style=" display: block; object-fit: cover; aspect-ratio: 16 / 9; width: 100% ">
                    <div class="x_div py-2 fkr-set1 fs-11">{{ navSlot[0].title }}</div>
                    <div class="fkr-set2 fs-09">{{ navSlot[0].description }}</div>
                </a>
            </div>
            <a href="javascript:void(0)" @click="moveNav(1)"
                style="display: flex; align-items: center; flex-shrink: 0;">
                <img src="@/assets/img/s_arrow_r.png" width="35px" height="35px">
            </a>
        </div>
        <div v-else class="d-flex align-items-center" style="justify-content: center; gap: 15px; height: 250px;">
            <a href="javascript:void(0)" @click="moveNav(0)"
                style="display: flex; align-items: center; flex-shrink: 0;">
                <img src="@/assets/img/s_arrow_l.png" width="50px" height="50px">
            </a>
            <div style="flex: 1; display: flex; gap: 20px;">
                <div class="iw-5" v-for="(v, i) in navSlot" :key="i" style="display: flex; flex-direction: column;">
                    <a class="w-100" :href="v.pageLink"
                        style="width: 100%; display: flex; flex-direction: column; flex: 1; ">
                        <img :src="v.imgSrc"
                            style="display: block; object-fit: cover; width: 100%; aspect-ratio: 16 / 9; flex: 1;">
                        <div class="py-3 px-2">
                            <div class="fkr-set1 fs-11">{{ v.title }}</div>
                            <div class="fkr-set2 fs-09">{{ v.description }}</div>
                        </div>
                    </a>
                </div>
            </div>
            <a href="javascript:void(0)" @click="moveNav(1)"
                style="display: flex; align-items: center; flex-shrink: 0;">
                <img src="@/assets/img/s_arrow_r.png" width="50px" height="50px">
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PortfolioNavigation',
    props: {
        isMobile: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            projects: [
                // 경쟁으로 인한 삭제.  - Declankim 2025.10.30.sprint1
                {
                    imgSrc: '/files/img/portfolio/thumbnails/thumb_sample6.jpg',
                    title: 'M Studio',
                    description: '정제된 모던함과 견고한 품질을 갖춘 체류형쉼터입니다.',
                    pageLink: '/menu/portfolio/mstudio'
                },
                {
                    imgSrc: '/files/img/portfolio/thumbnails/thumb_sample4.png',
                    title: 'M House',
                    description: '생애주기 맞춤형 유니버셜 모듈 조합 단독주택입니다.',
                    pageLink: '/menu/portfolio/mhouse'
                },
                {
                    imgSrc: '/files/img/portfolio/thumbnails/thumb_sample1.jpg',
                    title: 'M Commercial',
                    description: '바다를 담은 감각적인 근린생활시설입니다.',
                    pageLink: '/menu/portfolio/prj01'
                },
                {
                    imgSrc: '/files/img/portfolio/thumbnails/thumb_sample2.png',
                    title: 'M Office',
                    description: '감각적인 전면 파사드 디자인의 모듈러 상업시설입니다.',
                    pageLink: '/menu/portfolio/shingaloffice'
                },
                {
                    imgSrc: '/files/img/portfolio/thumbnails/thumb_sample3.jpg',
                    title: 'M School',
                    description: '재조립, 재사용이 가능한 친환경 모듈러 학교입니다.',
                    pageLink: '/menu/portfolio/mschool'
                },
            ],
            navSlot: [],
            index: 0,
            windowHeight: 0
        }
    },
    computed: {
        mobileImageHeight() {
            // 화면 높이에 따라 이미지 높이 동적 계산
            if (this.isMobile) {
                const screenHeight = window.innerHeight;
                // 화면 높이의 약 35% ~ 50% 범위로 설정 (최소 150px, 최대 300px)
                const height = Math.min(Math.max(Math.floor(screenHeight * 0.35), 150), 300);
                return height + 'px';
            }
            return '250px'; // PC는 고정값
        },
        mobileContainerHeight() {
            // 전체 컨테이너 높이 (이미지 + 텍스트 레이블)
            if (this.isMobile) {
                const screenHeight = window.innerHeight;
                const height = Math.min(Math.max(Math.floor(screenHeight * 0.4), 170), 330);
                return height + 'px';
            }
            return '300px';
        }
    },
    mounted() {
        this.setSlot();
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            this.windowHeight = window.innerHeight;
            this.$forceUpdate();
        },
        setSlot() {
            this.navSlot = [];
            for (var i = 0; i < 3; i++) {
                this.navSlot.push(this.projects[(this.index + i) % this.projects.length]);
            }
        },
        moveNav(direction) {
            if (direction) {
                this.index = (this.index + 1) % this.projects.length;
                this.setSlot();
            }
            else {
                if (this.index == 0) {
                    this.index = this.projects.length - 1;
                }
                else {
                    this.index--;
                }
                this.setSlot();
            }
        }
    }
}
</script>